import { TZDate } from "react-day-picker"

import { format } from "date-fns"

/** Keeps an unchanged calendar date's instant and normalizes only changed dates. */
export function applyDateOnlyInput(
  value: string,
  bound: Date | null,
  boundary: (date: Date) => Date,
  timeZone?: string,
) {
  if (!value) {
    return null
  }
  const calendarBound =
    bound && (timeZone ? new TZDate(bound, timeZone) : bound)
  if (calendarBound && format(calendarBound, "yyyy-MM-dd") === value) {
    return bound
  }

  const [year, month, day] = value.split("-").map(Number)
  // Numeric components avoid parsing the input in the browser's timezone first.
  const calendarDay = timeZone
    ? new TZDate(year, month - 1, day, 12, 0, 0, 0, timeZone)
    : new Date(`${value}T12:00:00`)
  return new Date(boundary(calendarDay).getTime())
}
